import { startGame } from '@fg/base/main';
import { Scene } from '@fg/base/scene';
import store from '@fg/base/store';

let bigWinShineAnim;

class GameScene extends Scene {
    update()
    {
        super.update();
    }

    init()
    {
        super.init();

        this.mainSound = this.sound.add('mus_general', {"loop":true});
        this.mainAmbSound = this.sound.add('amb_main', {"loop":true});

        this.mainSound.play();
        this.mainAmbSound.play();

        this.unluckyStarsCount = Config.odds.unlucky_stars ? Config.odds.unlucky_stars : 0;

        if (this.unluckyStarsCount > 5) {
            this.unluckyStarsCount = 5;
        }

        this.currentMultiplierWheelAngle = 0;

        store.commit('toggleExplanation', {
            callback: () => {
                this.letInitialize(() => {
                    this.prepareSounds();
                    this.properties();
                    this.positionerContainer = this.add.container();
                    this.mainGameGroup = this.add.container();
                    this.createBg();
                    this.createWheel();
                    this.createMultiplier();
                    this.createSanta();
                    this.createFader();
                    this.createBonus();
                    this.createFrontSnow();
                    this.addBigWinAnimations();
                    this.spritesReady = true;

                    this.baseGamePositioner();
                    this.canvasReady();
                });
            }
        });
    }

    afterPurchase()
    {
        this.tweens.add({
            targets: [this.mainSound, this.mainAmbSound],
            volume: 0.5,
            duration: 1000,
        });

        this.wheelSpinned = false;
        this.bonusFinished = false;
        this.multiplierSpinned = false;
        this.multiplierMultiplied = false;
        this.wheelStopIndex = false;
        this.wheelSpinning = false;
        this.wheelStoppedByHand = false;
        this.stoppingWheel = false;
        this.bonusRunning = false;

        this.afterPurchaseAnimation();

        store.commit('hidePlayButton');
    }

    afterPurchaseAnimation()
    {
        if (this.request.gamePlayedTimes > 0) {
            this.resetGame(() => {
            });
        } else {
            this.loadSymbols(() => {
            });
        }
    }

    createFrontSnow()
    {
        this.snowParticlesFront = this.add.particles('snow_particle');

        let width = 1920;

        this.snowParticlesFront.createEmitter({
            x: 0,
            y: -100,
            // emitZone
            emitZone: {
                source: new Phaser.Geom.Rectangle(-width * 3, 0, width * 7, 100),
                type: 'random',
                quantity: 70
            },
            speedY: { min: 50, max: 70 },
            speedX: { min: -20, max: 20 },
            accelerationY: { random: [10, 15] },
            // lifespan
            lifespan: { min: 8000, max: 15000 },
            scale: { random: [0.25, 0.75] },
            alpha: { random: [0.1, 0.8] },
            gravityY: 10,
            frequency: 30,
            blendMode: 'ADD',
        })
    }

    resetGame(callback)
    {
        for (let i = 1; i <= 3; i++) {
            this.gifts[i].setFrame(`Gift_0${i}_Open_0000.png`);
            this.gifts[i].mouseOverSprite.setAlpha(0);
            this.gifts[i].loose.setAlpha(0);
            this.gifts[i].giftPrizeGlow.setAlpha(0);
            this.gifts[i].amount.setAlpha(0);
            this.gifts[i].amountLost.setAlpha(0);
        }

        Config.odds.multipliers.forEach((item, index) => {
            this.multiplierWheelAmounts[index].lucky.setAlpha(0);
            this.multiplierWheelAmounts[index].setAlpha(1);
        });

        this.tweens.add({
            targets: [this.wheelStar, this.fullFaderMain, ...this.unluckyStars],
            alpha: 0,
            ease: 'Power0',
            duration: this.request.gamePlayedTimes > 0 ? 0 : 500,
            onComplete: () => {
                this.starParticles.emitter.stop();

                for (let i = 0; i < this.unluckyStarsCount; i++) {
                    this.unluckyStarsParticles[i].emitter.stop();
                }

                let color = '_dark';

                let maxTimeout = 0;

                this.sound.play('sfx_wheel_flip');

                this.request.scenario.wheel_symbols.forEach((item, index) => {
                    let timeout = Phaser.Math.RND.integerInRange(0, 1000);

                    if (timeout > maxTimeout) {
                        maxTimeout = timeout;
                    }

                    this.flipResetAmounts(item, index, color, timeout);

                    color = color === '_dark' ? '_light' : '_dark';
                });

                this.time.delayedCall(maxTimeout + 600, () => {
                    callback();

                    this.activateStars();

                    this.enableWheel();
                });
            }
        });
    }

    flipResetAmounts(item, index, color, timeout)
    {
        this.flipDownBoardAmount(this.wheelAmounts[index], index, color, timeout, () => {
            let amount = '-';

            if (item.win) {
                this.wheelStopIndex = index;
            }

            if (item.amount) {
                amount = item.amount;
            }

            this.flipUpBoardAmount(this.wheelAmounts[index], index, amount, color, 0);
        });
    }

    loadSymbols()
    {
        this.tweens.add({
            targets: this.fullFaderMain,
            alpha: 0,
            ease: 'Power0',
            duration: this.request.gamePlayedTimes > 0 ? 0 : 500,
            onComplete: () => {
                this.activateStars();

                let color = '_dark';

                let maxTimeout = 0;

                this.sound.play('sfx_wheel_flip');

                this.request.scenario.wheel_symbols.forEach((item, index) => {
                    let amount = '-';

                    if (item.win) {
                        this.wheelStopIndex = index;
                    }

                    if (item.amount) {
                        amount = item.amount;
                    }

                    let timeout = Phaser.Math.RND.integerInRange(0, 1000);

                    if (timeout > maxTimeout) {
                        maxTimeout = timeout;
                    }

                    this.flipUpBoardAmount(this.wheelAmounts[index], index, amount, color, timeout);

                    color = color === '_dark' ? '_light' : '_dark';
                });

                this.time.delayedCall(maxTimeout + 300, () => {
                    this.enableWheel();
                });
            }
        });
    }

    activateStars()
    {
        this.activateStar(this.wheelStar, this.request.scenario.star_position);

        for (let i = 0; i < this.unluckyStarsCount; i++) {
            this.activateStar(this.unluckyStars[i], this.request.scenario.unlucky_stars[i]);
        }

        this.starParticles.emitter.start();

        for (let i = 0; i < this.unluckyStarsCount; i++) {
            this.unluckyStarsParticles[i].emitter.start();
        }
    }

    enableWheelBoards(callback)
    {
        Object.values(this.wheelBoards).forEach((board) => {
            board.setInteractive({ cursor: 'pointer', draggable: true, pixelPerfect: true})
                .on('pointerup', (pointer) => {
                    if (callback) {
                        callback();
                    } else {
                        pointer.event.preventDefault();
                    }
                })
                .on('pointerover', (pointer) => {
                    if (!callback) {
                        pointer.event.preventDefault();
                    }
                })
                .on('pointerout', (pointer) => {
                    if (!callback) {
                        pointer.event.preventDefault();
                    }
                });
        })
    }

    disableWheelBoards()
    {
        Object.values(this.wheelBoards).forEach((board) => {
            this.customHelper.removeClickable(board);
        })
    }

    enableWheel()
    {
        this.wheelBase.setInteractive({ cursor: 'pointer', draggable: true, pixelPerfect: true})
            .on('pointerup', (pointer) => {
                pointer.event.preventDefault();
            })
            .on('pointerover', (pointer) => {
                pointer.event.preventDefault();
            })
            .on('pointerout', (pointer) => {
                pointer.event.preventDefault();
            });

        this.wheelDragRotate.setOrigin(this.wheelBase.x + this.wheelContainer.x, this.wheelBase.y + this.wheelContainer.y);

        this.enableWheelBoards();

        this.dragged = false;
        this.wheelDragRotate.setEnable(true);

        store.commit('showCustomPlayButton', 'icon_wheel.svg');
    }

    customPlayButtonEvent()
    {
        if (Config.assets.settings.disable_open_all && this.wheelSpinning) {
            this.stopWheel();

            this.sound.play('sfx_wheel_spin_press_stop');
        } else {
            this.spin('normal');
        }

        this.sound.play('sfx_button_click');
    }

    spin(direction)
    {
        if (this.wheelSpinned) {
            return;
        }

        this.customHelper.removeClickable(this.wheelBase);
        this.disableWheelBoards();

        this.wheelSpinning = true;
        this.wheelSpinned = true;

        const index = this.wheelStopIndex;

        this.currentSpinDirection = direction;

        this.customHelper.removeClickable(this.wheelBase);
        this.wheelDragRotate.setEnable(false);

        let finalAngle = direction === 'counter' ? this.wheelAngles[index] :  -(this.wheelAngles[index]);
        let rounds = 3;
        let spinTime = Config.assets.settings.disable_open_all ? (360 * 400) : 2000;
        let angle = Config.assets.settings.disable_open_all ? (360 * 360) : 360 * rounds + finalAngle;
        let offset = 3;

        if (direction === 'counter') {
            angle *= -1;
            offset *= -1;
        }

        this.wheelTween = this.tweens.add({
            targets: this.spinContainer,
            angle: angle + offset,
            ease: Config.assets.settings.disable_open_all ? 'Power0' : Phaser.Math.Easing.Quadratic.Out,
            duration: spinTime,
            repeat: Config.assets.settings.disable_open_all ? -1 : 0,
            onUpdate: () => {
                this.particleFollowStars();
            },
            onComplete: () => {
                this.finishWheelSpin(offset, index);
            }
        });

        this.spinMultiplier(direction);

        store.commit('hideCustomPlayButton');

        this.sound.play('sfx_wheel_spin_start');
        this.wheelSpinLoop.play();

        if (Config.assets.settings.disable_open_all) {
            this.time.delayedCall(1000, () => {
                if (!this.stoppingWheel) {
                    store.commit('showCustomPlayButton', 'icon-wheel_stop.svg');
                }

                this.enableWheelBoards(() => {
                    this.stopWheel();
                });

                this.wheelBase.setInteractive({ cursor: 'pointer', pixelPerfect: true})
                    .once('pointerup', () => {
                        this.stopWheel();
                    });
            });

        } else {
            this.time.delayedCall(500, () => {
                this.finishMultiplierSpin();
            });
        }
    }

    spinMultiplier(direction)
    {
        this.multiplierSpinningByUpdate = true;

        let spinTime = (360 * 400);
        let angle = (360 * 360);

        if (direction !== 'counter') {
            angle *= -1;
        }

        this.multiplierWheelTween = this.tweens.add({
            targets: this.multiplierSpinContainer,
            angle: angle,
            ease: 'Power0',
            duration: spinTime,
            repeat: -1,
        });
    }

    finishWheelSpin(offset, index)
    {
        this.tweens.add({
            targets: this.spinContainer,
            angle: this.spinContainer.angle + (offset * -1),
            ease: 'Power0',
            duration: 400,
            onUpdate: () => {
                this.particleFollowStars();
            },
        });
    }

    showWheelWinning()
    {
        let index = this.wheelStopIndex;

        if (this.request.scenario.wheel_symbols[index].amount > 0) {
            this.wheelContainer.bringToTop(this.wheelWinFx);

            this.tempMatrix = new Phaser.GameObjects.Components.TransformMatrix();
            this.tempParentMatrix = new Phaser.GameObjects.Components.TransformMatrix();

            this.wheelAmounts[index].amount.getWorldTransformMatrix(this.tempMatrix, this.tempParentMatrix);
            let decompressed = this.tempMatrix.decomposeMatrix();

            this.setWheelAmount(this.wheelAmounts[index], this.request.scenario.wheel_symbols[index].amount, '_active');

            this.wheelWinFx.setX(decompressed.translateX - this.wheelContainer.x).setY(decompressed.translateY - this.wheelContainer.y);
            this.wheelWinFx.play('win_fx');
            this.sound.play('sfx_win_wheel_explosion_01');

            this.request.addAmountWon(this.request.scenario.wheel_symbols[index].amount);

            this.tweens.add({
                targets: this.wheelAmounts[index].amount,
                scale: 1.2,
                ease: 'Power0',
                yoyo: true,
                duration: 300,
                onComplete: () => {
                    this.checkForContinueGame();
                }
            });
        } else {
            this.checkForContinueGame();
        }
    }

    finishMultiplierSpin()
    {
        const index = Config.odds.multipliers.findIndex((value) => {return value === this.request.scenario.multiplier;});

        let finalAngle = this.currentSpinDirection === 'counter' ? -(this.multiplierWheelAnglesCounter[index]) : this.multiplierWheelAnglesCounter[index] ;

        let angle = (360 * 2) + finalAngle;

        let distance = Math.abs(angle - this.multiplierSpinContainer.angle);
        let spinTime = distance / 360 * 1100;

        if (this.currentSpinDirection !== 'counter') {
            angle *= -1;
        }

        this.time.delayedCall(spinTime - 50, () => {
            this.wheelSpinLoop.stop();
            this.sound.play('sfx_wheel_spin_stop');
            this.wheelSpinLoop.stop();
        });

        this.tweens.add({
            targets: this.multiplierSpinContainer,
            angle: angle,
            ease: Phaser.Math.Easing.Quadratic.Out,
            duration: spinTime,
            onUpdate: () =>  {
                this.multiplierWheelTween.stop();
                if (this.multiplierSpinningByUpdate) {
                    this.multiplierSpinningByUpdate = false;
                }
            },
            onComplete: () => {
                this.showWheelWinning();
                this.currentMultiplierWheelAngle = this.multiplierSpinContainer.angle;
            }
        });
    }

    flyToAmount(fromSprite, toSpriteAmount, amount, callback)
    {
        this.tempMatrix = new Phaser.GameObjects.Components.TransformMatrix();
        this.tempParentMatrix = new Phaser.GameObjects.Components.TransformMatrix();

        fromSprite.getWorldTransformMatrix(this.tempMatrix, this.tempParentMatrix);
        let decompressed = this.tempMatrix.decomposeMatrix();

        this.tempMatrix = new Phaser.GameObjects.Components.TransformMatrix();
        this.tempParentMatrix = new Phaser.GameObjects.Components.TransformMatrix();

        toSpriteAmount.amount.getWorldTransformMatrix(this.tempMatrix, this.tempParentMatrix);
        let decompressed2 = this.tempMatrix.decomposeMatrix();

        this.wheelContainer.bringToTop(this.wheelWinFx);
        this.wheelWinFx.setX(decompressed.translateX - this.wheelContainer.x).setY(decompressed.translateY - this.wheelContainer.y);
        this.wheelWinFx.play('win_fx');

        this.flyParticleTo(decompressed.translateX, decompressed.translateY, decompressed2.translateX, decompressed2.translateY, 0, () => {
            this.setWheelAmount(toSpriteAmount, amount, '_active');

            callback();

            this.wheelContainer.bringToTop(this.wheelWinFx);
            this.wheelWinFx.setX(decompressed2.translateX - this.wheelContainer.x).setY(decompressed2.translateY - this.wheelContainer.y);
            this.wheelWinFx.play('win_fx');

            toSpriteAmount.amount.setAlpha(1);

            this.tweens.add({
                targets: toSpriteAmount.amount,
                scale: 1.2,
                ease: 'Power0',
                yoyo: true,
                duration: 300,
            });
        });
    }

    flyParticleTo(startX, startY, destinationX, destinationY, delay, callback, callbackParams)
    {
        this.time.delayedCall(delay, () => {
            let startPoint = new Phaser.Math.Vector2(startX, startY);
            let distance = Phaser.Math.Distance.Between(startX, startY, destinationX, destinationY);
            let halfDistance = distance / 2;
            let quarterDistance = distance / 4;
            let controlX = startX - quarterDistance;

            if (destinationX > startX) {
                controlX = startX + quarterDistance;
            }

            let controlY = startY - halfDistance;

            if (destinationY > startY) {
                controlY = startY + halfDistance;
            }

            let controlPoint1 = new Phaser.Math.Vector2(controlX, controlY);

            let endPoint = new Phaser.Math.Vector2(destinationX, destinationY);

            let curve = new Phaser.Curves.QuadraticBezier(startPoint, controlPoint1, endPoint);
            let newDistance = curve.getLength();

            let scaler = 0.5;
            let itemsCount = 15;

            for (var i = 0; i < itemsCount; i++) {
                this.addFollower(curve, newDistance, scaler, i, callback, callbackParams);

                scaler -= (0.5 / (itemsCount * 1.2));
            }
        }, {}, this);
    }
    
    addFollower(path, distance, scaler, i, callback, callbackParams)
    {
        let follower = this.add.follower(path, 100, 100, 'flares', 'yellow');
        follower.setDepth(10);
        follower.setBlendMode(Phaser.BlendModes.ADD);
        follower.setScale(scaler);

        follower.startFollow({
            duration:distance * 1.5,
            positionOnPath: true,
            ease: 'Linear',
            delay: i * 9,
            onComplete: () => {
                follower.destroy();

                if (i === 0) {
                    if (callback) {
                        callback(callbackParams);
                    }
                }
            }
        });
    }

    stopWheel()
    {
        this.stoppingWheel = true;

        if (this.wheelStoppedByHand) {
            return;
        }

        this.customHelper.removeClickable(this.wheelBase);

        this.disableWheelBoards();

        this.wheelStoppedByHand = true;

        store.commit('hideCustomPlayButton');

        const index = this.wheelStopIndex;

        this.wheelTween.stop();

        let finalAngle = this.currentSpinDirection === 'counter' ? this.wheelAngles[index] :  -(this.wheelAngles[index]);
        let angle = (360 * 2) + finalAngle;
        let offset = 3;

        let distance = Math.abs(angle - this.spinContainer.angle);

        let spinTime = distance / 360 * 1100;

        if (this.currentSpinDirection === 'counter') {
            angle *= -1;
            offset *= -1;
        }

        this.time.delayedCall(spinTime / 2, () => {
            this.finishMultiplierSpin();
        });

        this.wheelTween = this.tweens.add({
            targets: this.spinContainer,
            angle: angle + offset,
            ease: Phaser.Math.Easing.Quadratic.Out,
            duration: spinTime,
            onUpdate: () => {
                this.particleFollowStars();
            },
            onComplete: () => {
                this.finishWheelSpin(offset, index);
            }
        });
    }

    flipUpBoardAmount(item, index, amount, color, timeout)
    {
        this.time.delayedCall(timeout, () => {
            this.setWheelAmount(item, amount, color);
            this.spinContainer.add(item.amount);
            const scaleTo = item.amount.scaleX;
            item.amount.setScale(scaleTo, 0);

            this.tweens.add({
                targets: item.amount,
                scaleY: scaleTo,
                duration: 100,
                delay: 100
            });

            this.wheelBoards[index].play(this.wheelBoardSettings[index].spriteName);
        });
    }

    flipDownBoardAmount(item, index, color, timeout, callback)
    {
        this.time.delayedCall(timeout, () => {
            this.tweens.add({
                targets: item.amount,
                scaleY: 0,
                duration: 100,
            });

            this.wheelBoards[index].playReverse(this.wheelBoardSettings[index].spriteName);

            this.wheelBoards[index].once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
                callback();
            });
        });
    }

    activateStar(star, i)
    {
        this.setStarPosition(star, i);
        const prevAngle = star.angle;
        star.setScale(0).setAngle(prevAngle + 90).setAlpha(1);

        this.tweens.add({
            targets: star,
            scale: 1,
            angle: prevAngle,
            duration: 300,
            onComplete: () => {
                star.play('gift_loop');
            }
        });
    }

    setWheelAmount(item, givenAmount, color)
    {
        let amount = givenAmount;

        if (givenAmount !== '-') {
            amount = General.format_currency(givenAmount).replace(Config.currency.symbol, '');
        }

        let x = item.amount.x;
        let y = item.amount.y;
        let angle = item.amount.angle;

        item.amount.destroy();

        item.amount = this.customHelper.createWinningFromSprites(amount, 0.6, color).setX(x).setY(y).setAngle(angle);
        item.amount.setX(x).setY(y);
        this.spinContainer.add(item.amount);

        this.customHelper.applyDynamicSpriteSize(item.amount, 170);
    }

    createSanta()
    {
        this.santa = this.add.sprite(0, 0, 'santa').setOrigin(0, 1).setFrame('Santa_Animation_0000.png');
        this.wizardSmoke = this.add.sprite(0, 0, 'wizard_smoke').setVisible(false);

        let animationConfig = {
            key: 'santa',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('santa', {
                prefix: 'Santa_Animation_',
                start: 0,
                end: 31,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'wizard_smoke',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('wizard_smoke', {
                start: 0,
                end: 37,
            }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true
        };

        this.anims.create(animationConfig);
        this.playSmoke();

        this.glow_for_logo = this.add.sprite(0, 0, 'glow_for_logo');
        this.logo = this.add.sprite(0, 0, 'logo');

        this.glow_for_logo.tween = this.tweens.add({
            targets: this.glow_for_logo,
            alpha: 0.8,
            scale: 0.8,
            yoyo: 1,
            repeat: -1,
            duration: 3000
        });
    }

    playSmoke()
    {
        this.wizardSmoke.play('wizard_smoke');

        if (!this.bonusRunning) {
            this.sound.play('sfx_smoking', {'volume': 0.3});
        }

        this.time.delayedCall(Phaser.Math.RND.integerInRange(9000, 16000), () => {
            this.playSmoke();
        });
    }

    beforePurchase()
    {
        this.sound.play('sfx_button_click');
    }

    prepareSounds()
    {
        this.bonusSound = this.sound.add('mus_bonus', {"loop":true, "volume": 0});
        this.bonusSoundAmb = this.sound.add('amb_bonus', {"loop":true, "volume": 0});

        this.pointCountSound = this.sound.add('sfx_big_win_counter_loop', {"loop":true, "volume": 1});
        this.wheelSpinLoop = this.sound.add('sfx_wheel_spin_loop', {"loop":true, "volume": 1});

        this.bigWinStartSound = this.sound.add('sfx_big_win_counter_start');
    }

    checkForContinueGame()
    {
        if (this.request.scenario.bonus && !this.bonusFinished) {
            this.showBonus();
            return;
        }

        if (this.request.scenario.multiplier && !this.multiplierMultiplied && this.request.scenario.total_prize > 0) {
            this.markMultiplier();
            return;
        }

        this.finishGame();
    }

    showBonus()
    {
        this.bigWinSoundTween = this.tweens.add({
            targets: [this.mainSound, this.mainAmbSound],
            volume: 0,
            duration: 500,
            onComplete: () => {
                this.mainSound.stop();
                this.mainAmbSound.stop()
            }
        });

        this.bonusSound.play();
        this.bonusSoundAmb.play();

        this.tweens.add({
            targets:  [this.bonusSound, this.bonusSoundAmb],
            volume:  1,
            duration: 500
        });

        this.santa.play('santa');
        this.sound.play('sfx_staff');
        this.bonusRunning = true;

        store.commit('hideCustomPlayButton');
        store.commit('hideOpenAllButton');
        store.commit('hidePlayButton');

        this.wheelStar.play('bonus_gift_activate');
        this.sound.play('sfx_bonus_gift_explode');
        this.starParticles.emitter.stop();

        this.wheelStar.once(Phaser.Animations.Events.ANIMATION_COMPLETE, () => {
            this.sound.play('sfx_bonus_intro');

            this.wheelStar.setAlpha(0).setTexture('gift_loop', 'Gift_Idle_Loop_0000.png').play('gift_loop');
            this.fadeInMainFader(0.8);
            this.children.bringToTop(this.bonusContainer);

            for (let i = 1; i <= 3; i++) {
                this.gifts[i].setAlpha(0);
            }

            this.bonusContainer.setY(this.cameras.main.height + this.bonusSnow.displayHeight).setAlpha(1);
            this.bonusSnow.setAlpha(1);
            this.bonusSnowFront.setAlpha(1);

            this.tweens.add({
                targets: this.wheelStar,
                alpha: 1,
                duration: 500,
                delay: 500,
                onComplete: () => {
                    this.starParticles.emitter.start();
                }
            });

            this.bonusContainer.tween = this.tweens.add({
                targets: this.bonusContainer,
                y: this.bonusContainer.initialY,
                duration: 500,
                ease: 'Power0',
                onComplete: () => {
                    this.playBonusIntro();
                }
            });
        });
    }

    playBonusIntro()
    {
        for (let i = 1; i <= 3; i++) {
            this.playGiftsOutAnimations(this.gifts[i], i);
        }
    }

    playGiftsOutAnimations(item, i)
    {
        let delay = i !== 2 ? 100 : 0;

        item.setY(-(item.displayHeight / 2)).setAlpha(1).setFrame(`Gift_0${i}_Open_0000.png`);

        item.tween = this.tweens.add({
            targets: item,
            y: item.initialY,
            duration: 400,
            delay: delay,
            ease: Phaser.Math.Easing.Sine.In,
            onComplete: () => {
                item.tween = this.tweens.add({
                    targets: item,
                    y: item.initialY + 20,
                    scaleY: 0.9,
                    duration: 100,
                    ease: 'Power0',
                    yoyo: true,
                    onComplete: () => {
                        if (i === 1) {
                            this.activateGifts();
                        }
                    }
                });
            }
        });
    }

    activateGifts()
    {
        this.giftOpened = false;

        for (let i = 1; i <= 3; i++) {
            this.activateGift(this.gifts[i], i);
        }

        this.enableIdleTimer();
    }

    activateGift(item, i)
    {
        item.setInteractive({cursor: 'pointer', pixelPerfect: true})
            .on('pointerup', () => {
                this.openGift(item, i);
            })
            .on('pointerover', () => {

                if (item.mouseOverSprite.tween && item.mouseOverSprite.tween.isPlaying()) {
                    item.mouseOverSprite.tween.stop();
                }

                item.mouseOverSprite.tween = this.tweens.add({
                    targets: item.mouseOverSprite,
                    alpha: 1,
                    duration: 100,
                    ease: 'Power0'
                });

                this.sound.play('sfx_bonus_mouse_over_0' + i);
            })
            .on('pointerout', () => {
                if (item.mouseOverSprite.tween && item.mouseOverSprite.tween.isPlaying()) {
                    item.mouseOverSprite.tween.stop();
                }

                item.mouseOverSprite.tween = this.tweens.add({
                    targets: item.mouseOverSprite,
                    alpha: 0,
                    duration: 100,
                    ease: 'Power0'
                });
            });
    }

    enableIdleTimer()
    {
        this.idleTimer = this.time.addEvent({
            delay: 10000,
            callback: this.shakeUnopenedSymbols,
            callbackScope: this,
            loop: true
        });

        this.shakeUnopenedSymbols();
    }

    stopIdleTimer()
    {
        if (this.idleTimer) {
            this.idleTimer.remove();
        }
    }

    shakeUnopenedSymbols()
    {
        if (this.giftOpened) {
            return;
        }

        for (let i = 1; i <= 3; i++) {
            if (this.gifts[i].mouseOverSprite.alpha === 0) {
                this.gifts[i].mouseOverSprite.tween = this.tweens.add({
                    targets: this.gifts[i].mouseOverSprite,
                    alpha: 1,
                    duration: 300,
                    delay: Phaser.Math.RND.integerInRange(0, 50),
                    ease: 'Power0',
                    yoyo: true,
                    repeat: 3
                });
            }
        }
    }

    openGift(item, index)
    {
        if (this.giftOpened) {
            return;
        }

        this.stopIdleTimer();

        this.giftOpened = true;

        this.sound.play('sfx_bonus_click');

        for (let i = 1; i <= 3; i++) {
            this.customHelper.removeClickable(this.gifts[i]);
            if (this.gifts[i].mouseOverSprite.tween && this.gifts[i].mouseOverSprite.tween.isPlaying()) {
                this.gifts[i].mouseOverSprite.tween.stop();
                this.gifts[i].mouseOverSprite.setAlpha(0);
            }
        }

        this.setGiftAmount(item, this.request.scenario.bonus.luckies[0], '_bonus_win');

        item.mouseOverSprite.setAlpha(0);
        item.play(`gift_${index}_open`);

        item.giftPrizeGlow.play('win_glow').setScale(1).setAlpha(1);

        let scaleTo = item.amount.scaleX;
        item.amount.setScale(0).setAlpha(1);

        this.giftIndexOpened = index;
        let delay = 200;

        this.add.tween({
            targets: item.giftPrizeGlow,
            scale: 1,
            duration: 200,
            delay: delay,
            ease: 'Power0',
        });

        this.add.tween({
            targets: item.amount,
            scale: scaleTo,
            duration: 200,
            delay: delay,
            ease: 'Power0',
        });

        this.time.delayedCall(1000, () => {
            this.showUnluckyGifts();
        });
    }

    showUnluckyGifts()
    {
        let indexOnScenario = 0;

        for (let i = 1; i <= 3; i++) {
            if (i === this.giftIndexOpened) {
                continue;
            }

            this.showUnluckyGift(this.gifts[i], this.request.scenario.bonus.unluckies[indexOnScenario], (indexOnScenario * 300), indexOnScenario > 0);

            indexOnScenario++;
        }
    }

    showUnluckyGift(item, amount, delay, isLast)
    {
        this.time.delayedCall(delay, () => {
            this.setGiftAmount(item, amount, '_bonus_loose', 'unlucky');
            let toY = item.amountLost.y;

            item.amountLost.y = item.amount.y;

            item.amountLost.tween = this.add.tween({
                targets: item.amountLost,
                alpha: 1,
                y: toY,
                duration: 200,
                ease: 'Power0',
            });

            this.add.tween({
                targets: item.loose,
                alpha: 1,
                duration: 100,
                ease: 'Power0',
            });

            if (isLast) {
                this.time.delayedCall(2000, () => {
                    this.finishBonus();
                });
            }
        });
    }

    finishBonus()
    {
        this.bonusFinished = true;
        this.tweens.add({
            targets: this.fullFaderMain,
            alpha: 0,
            duration: 300
        });

        this.sound.play('sfx_bonus_close');

        this.tweens.add({
            targets:  [this.bonusSound, this.bonusSoundAmb],
            volume:  0,
            duration: 500,
            onComplete: () => {
                this.bonusSound.stop();
                this.bonusSoundAmb.stop()
            }
        });

        this.mainSound.play();
        this.mainAmbSound.play();

        this.tweens.add({
            targets: [this.mainSound, this.mainAmbSound],
            volume: 0.5,
            duration: 500,
        });

        this.bonusContainer.tween = this.tweens.add({
            targets: this.bonusContainer,
            y: this.cameras.main.height + this.bonusSnow.height,
            duration: 300,
            ease: 'Power0',
            onComplete: () => {
                this.bonusContainer.setAlpha(0).setY(this.bonusContainer.initialY);

                this.time.delayedCall(500, () => {
                    let amount = this.request.scenario.wheel_symbols[this.wheelStopIndex].amount + this.request.scenario.bonus.luckies[0];

                    this.sound.play('sfx_star_trail');
                    this.flyToAmount(this.wheelStar, this.wheelAmounts[this.wheelStopIndex], amount, () => {
                        this.sound.play('sfx_win_wheel_explosion_01');
                        this.request.addAmountWon(this.request.scenario.bonus.luckies[0]);

                        this.time.delayedCall(1000, () => {
                            this.markMultiplier();
                        });
                    });
                });
            }
        });
    }

    markMultiplier()
    {
        this.multiplierMultiplied = true;

        if (this.request.scenario.multiplier > 1 && this.request.scenario.total_prize > 0) {
            let amount = this.request.scenario.total_prize;

            const index = Config.odds.multipliers.findIndex((value) => {return value === this.request.scenario.multiplier;});

            this.multiplierWheelAmounts[index].lucky.setAlpha(1).setScale(1.2);
            this.multiplierWheelAmounts[index].setAlpha(0);
            this.santa.play('santa');
            this.sound.play('sfx_staff');
            this.time.delayedCall(1000, () => {
                this.sound.play('sfx_star_trail');
                this.flyToAmount(this.multiplierWheelAmounts[index], this.wheelAmounts[this.wheelStopIndex], amount, () => {
                    this.request.setAmountWon(this.request.scenario.total_prize);
                    this.sound.play('sfx_win_wheel_explosion_02');
                    this.tweens.add({
                        targets: this.multiplierWheelAmounts[index].lucky,
                        scale: 1,
                        duration: 300,
                        delay: 500,
                        ease: 'Power0',
                        onComplete: () => {
                            this.time.delayedCall(1000, () => {
                                this.checkForContinueGame();
                            });
                        }
                    });
                });
            });
        } else {
            this.checkForContinueGame();
        }
    }

    setGiftAmount(item, givenAmount, color, type)
    {
        const amount = General.format_currency(givenAmount).replace(Config.currency.symbol, '');

        if (type === 'unlucky') {
            var amountObj = item.amountLost;
        } else {
            var amountObj = item.amount;
        }

        let x = amountObj.x;
        let y = amountObj.y;
        let angle = amountObj.angle;

        amountObj.destroy();

        amountObj = this.customHelper.createWinningFromSprites(amount, 1, color, -10).setAngle(angle).setAlpha(0);
        amountObj.setX(x).setY(y);
        this.bonusContainer.add(amountObj);

        this.customHelper.applyDynamicSpriteSize(amountObj, 250);

        if (type === 'unlucky') {
            item.amountLost = amountObj;
        } else {
            item.amount = amountObj;
        }
    }


    destroyRegularWin()
    {
        if (this.regularWinDestroyed) {
            return;
        }

        this.regularWinDestroyed = true;

        this.customHelper.removeClickable(this.regularWinContainer);

        if (this.regularWinTimer) {
            this.regularWinTimer.remove();
        }

        this.tweens.add({
            targets: this.fullFaderMain,
            alpha: 0,
            ease: 'Power0',
            duration: 300,
        });

        this.tweens.add({
            targets: [this.regularWinParticles, this.regularPrizeUnderGlow, this.regularWin],
            scale: 0,
            ease: 'Power0',
            duration: 300,
            onComplete: () => {
                this.regularPrizeUnderGlow.setAlpha(0);
                this.regularWinParticles.setAlpha(0);

                this.regularWinParticles.emitter.stop();
                this.regularWinParticles.triggerTimer.paused = true;

                this.regularWinParticles.destroy();

                if (this.regularWinContainer) {
                    this.regularWinContainer.destroy();
                }

                if (this.regularWin) {
                    this.regularWin.destroy();
                }

                this.ticketFinished();
            }
        });
    }

    createDustEmitter2(x, y, width, height, maxParticleSize, type, quantity, toAlphaZero)
    {
        let circle;

        if (type === 'curve') {
            circle = new Phaser.Curves.Ellipse(x, y, width, height);
        } else {
            circle = new Phaser.Geom.Ellipse(x, y, width, height);
        }

        let particles = this.add.particles('snowflakes');

        maxParticleSize = maxParticleSize ? maxParticleSize : 0.1;
        quantity = quantity ? quantity : 1;

        let config = {
            frame: ['Snowflake_1.png', 'Snowflake_2.png', 'Snowflake_3.png', 'Snowflake_4.png'],
            lifespan: {
                'min': 500,
                'max': 2000
            },
            speedX: {
                min: -90,
                max: 90
            },
            speedY: {
                min: -70,
                max: 70
            },
            quantity: quantity,
            scale: {
                min: 0.01,
                max: maxParticleSize,
                end: 0
            },
            blendMode: 'ADD',
            frequency: 50,
            emitZone: {
                type: 'random',
                source: circle,
                quantity: 10,
                stepRate: 1,
                yoyo: false,
                seamless: true
            },
            on: false
        };

        if (toAlphaZero) {
            config['alpha'] =  { start: 1, end: 0, ease: 'Expo.easeIn'};
        }

        particles.emitter = particles.createEmitter(config);

        let currentGravityX = 50;

        particles.triggerTimer = this.time.addEvent({
            callback: () => {
                currentGravityX = currentGravityX * -1
                particles.emitter.setGravity(currentGravityX, 0);
            },
            callbackScope: this,
            delay: 1000,
            loop: true,
            paused: true
        });

        return particles;
    }

    showRegularWin()
    {
        this.regularWinDestroyed = false;
        this.regularWinContainer = this.add.container();
        this.fadeInMainFader(0.4);
        this.children.bringToTop(this.regularWinContainer);

        this.regularPrizeUnderGlow = this.add.sprite(0, 0, 'regular_win_glow').setOrigin(0.5).setScale(0);
        this.regularWinContainer.add(this.regularPrizeUnderGlow);

        this.regularWinParticles = this.createDustEmitter2(0, 0, 300, 100, 0.5, 'curve', 3, true);
        this.regularWinContainer.add(this.regularWinParticles);

        const amount = General.format_currency(this.request.scenario.total_prize).replace(Config.currency.symbol, '');

        this.regularWin = this.customHelper.createWinningFromSprites(amount, 1, '_win', -20).setAlpha(0);
        this.regularWinContainer.add(this.regularWin);

        this.customHelper.applyDynamicSpriteSize(this.regularWin, 530);

        let scaleTo = this.regularWin.scaleX;

        this.regularWin.setScale(0).setAlpha(1);

        this.regularWinPositioner();

        this.tweens.add({
            targets: [this.regularWinParticles, this.regularPrizeUnderGlow],
            scale: 1,
            ease: 'Power0',
            duration: 300,
        });

        this.regularWinParticles.emitter.start();
        this.regularWinParticles.triggerTimer.paused = false;

        this.sound.play('sfx_small_win_amount');

        this.tweens.add({
            targets: this.regularWin,
            scale: scaleTo + 0.2,
            ease: 'Power0',
            duration: 300,
            onComplete: () => {
                this.tweens.add({
                    targets: this.regularWin,
                    scale: scaleTo,
                    ease: 'Power0',
                    duration: 100,
                    onComplete: () => {

                        this.regularWinContainer.setInteractive({ cursor: 'pointer'})
                            .once('pointerup', () => {
                                this.destroyRegularWin();
                            });

                        this.regularWinTimer = this.time.delayedCall(1500, () => {
                            this.destroyRegularWin();
                        });
                    }
                });
            }
        });
    }

    regularWinPositioner()
    {
        if (!this.regularWinContainer) {
            return;
        }

        this.regularWinContainer.x = this.wheelContainer.x;
        this.regularWinContainer.y = this.wheelContainer.y;
        this.regularWinContainer.setSize(this.cameras.main.width, this.cameras.main.height);
    }

    addBigWinAnimations()
    {
        let animationConfig = {
            key: 'spark_big_win',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNumbers('spark_big_win', {
                start: 0,
                end: 21,
            }),
            frameRate: 25,
        };

        bigWinShineAnim = this.anims.create(animationConfig);

        this.bigWinShineParticles = this.add.particles('spark_big_win');

        this.bigWinShineEmitter = this.bigWinShineParticles.createEmitter({
            x: this.cameras.main.centerX,
            y: this.cameras.main.centerY,
            lifespan: 3000,
            particleClass: AnimatedParticle,
            quantity: 1,
            frequency: 50,
            scale: { start: 1, end: 0, ease: Phaser.Math.Easing.Expo.In },
            angle: { min: 0, max: 360 },
            on: false,
            alpha: {
                start: 0,
                end: 1,
            }
        });

        this.bigWinShineParticles2 = this.add.particles('snowflakes');

        this.bigWinShineEmitter2 = this.bigWinShineParticles2.createEmitter({
            frame: [ 'Snowflake_1.png', 'Snowflake_2.png', 'Snowflake_3.png', 'Snowflake_4.png' ],
            speed: { min: -100, max: 100 },
            x: this.cameras.main.centerX,
            y: this.cameras.main.centerY,
            lifespan: 3000,
            quantity: 2,
            scale: { start: 1, end: 0, ease: Phaser.Math.Easing.Expo.In },
            blendMode: 'ADD',
            frequency: 100,
            on: false,
            alpha: {
                start: 0,
                end: 1,
            }
        });
    }

    showBigWin()
    {
        this.bigWinStartSound.play();
        this.bigWinDestroyed = false;
        this.bigWinContainer = this.add.container();
        this.bigWinContainer.setAlpha(0);

        this.bigWinBaseGlow = this.add.sprite(0, 0, 'glow').setScale(0);
        this.bigWinContainer.add(this.bigWinBaseGlow);
        let checkerSizes = this.customHelper.createWinningFromSprites(General.format_currency(this.request.scenario.total_prize).replace(Config.currency.symbol, ''), 1, '_win', -20).setAlpha(0);
        this.customHelper.applyDynamicSpriteSize(checkerSizes, 730);
        let scaleAmount = checkerSizes.scaleX;

        this.bigWinAmountContainer = this.customHelper.createWinningFromSprites(General.format_currency(0).replace(Config.currency.symbol, ''), 1, '_win', -20).setScale(0);
        checkerSizes.destroy();

        this.bigWinContainer.add(this.bigWinAmountContainer);

        this.bigWinPositioner();

        this.fadeInMainFader(0.4);

        this.bigWinShineEmitter.start().setAlpha(1);
        this.bigWinShineEmitter2.start().setAlpha(1);

        this.children.bringToTop(this.bigWinShineParticles);
        this.children.bringToTop(this.bigWinShineParticles2);
        this.children.bringToTop(this.bigWinContainer);

        this.bigWinContainer.setAlpha(1);

        this.bigWinBaseGlow.tween = this.tweens.add({
            targets: [this.bigWinBaseGlow],
            scale: 0.9,
            ease: 'Power0',
            duration: 400,
            onComplete: () => {
                this.bigWinBaseGlow.tween = this.tweens.add({
                    targets: [this.bigWinBaseGlow],
                    scale: 1,
                    ease: 'Power0',
                    yoyo: true,
                    repeat: -1,
                    duration: 1300,
                });
            }
        });

        this.sound.play('mus_win_stinger');

        this.tweens.add({
            targets: this.bigWinAmountContainer,
            scale: scaleAmount,
            ease: 'Power0',
            duration: 200,
            delay: 100,
            onComplete: () => {
                this.incrementTo(this.request.scenario.total_prize);
                this.bigWinContainer.setInteractive({ cursor: 'pointer'})
                    .once('pointerup', () => {
                        this.pointCountSound.stop();
                        this.bigWinStartSound.stop();
                        this.destroyBigWin();
                    });
            }
        });
    }

    incrementTo(winning)
    {
        let lastAmount = 0;
        let delay = 0;

        if (lastAmount === winning) {
            this.setAmountText(delay, winning, true, 1, callback)
        } else {
            if (!this.pointCountSound.isPlaying) {
                this.pointCountSound.play();
            }

            var incrementSize = winning / 46;

            if (incrementSize < 0.01) {
                incrementSize = 0.01;
            }

            if (parseFloat(incrementSize) > 1) {
                incrementSize = Math.ceil(incrementSize);
            }

            while (lastAmount !== winning) {
                lastAmount += incrementSize;

                if (lastAmount > winning) {
                    lastAmount = winning;
                }

                this.setAmountText(delay, lastAmount, lastAmount === winning)

                delay += 55;
            }
        }
    }

    setAmountText(delay, amount, last)
    {
        amount = General.format_currency(amount).replace(Config.currency.symbol, '');

        this.time.delayedCall(delay, () => {
            if (this.bigWinDestroyed) {
                return;
            }

            let scale = this.bigWinAmountContainer.scaleX;
            let x = this.bigWinAmountContainer.x;
            let y = this.bigWinAmountContainer.y;

            this.bigWinAmountContainer.destroy();

            if (this.bigWinDestroyed) {
                return;
            }

            this.bigWinAmountContainer = this.customHelper.createWinningFromSprites(amount, 1, '_win', -20)
                .setX(x)
                .setY(y)
                .setScale(scale);

            this.bigWinContainer.add(this.bigWinAmountContainer);

            if (last) {
                this.pointCountSound.stop();
                this.sound.play('sfx_big_win_amount');
                this.tweens.add({
                    targets: this.bigWinAmountContainer,
                    scale: parseFloat(this.bigWinAmountContainer.scaleX) + 0.2,
                    ease: 'Power0',
                    duration: 100,
                    yoyo: true,
                    onComplete: () => {
                        this.time.delayedCall(2000, () => {
                           this.destroyBigWin();
                        });
                    }
                });
            }
        }, this);
    }

    destroyBigWin()
    {
        this.stopBigWinTweens();

        if (this.bigWinDestroyed) {
            return;
        }

        this.sound.play('sfx_big_win_close');

        this.bigWinDestroyed = true;

        this.customHelper.removeClickable(this.bigWinContainer);

        this.tweens.add({
            targets: [this.bigWinBaseGlow, this.bigWinAmountContainer],
            scale: 0,
            ease: 'Power0',
            duration: 300,
            onComplete: () => {
                this.ticketFinished();
            }
        });

        this.bigWinShineEmitter.stop().setAlpha(0);
        this.bigWinShineEmitter2.stop().setAlpha(0);
    }

    bigWinPositioner()
    {
        if (!this.bigWinContainer) {
            return;
        }

        this.bigWinContainer.x = this.wheelContainer.x;
        this.bigWinContainer.y = this.wheelContainer.y;

        this.bigWinContainer.setSize(this.cameras.main.width, this.cameras.main.height);
    }

    stopBigWinTweens()
    {
        if (this.bigWinBaseGlow.tween && this.bigWinBaseGlow.tween.isPlaying()) {
            this.bigWinBaseGlow.tween.stop();
        }
    }

    finishGame()
    {
        if (this.request.scenario.total_prize > 0) {
            const ratio = this.request.scenario.total_prize / this.request.ticketAmount;

            if (ratio >= Config.assets.ratios.big_win) {
                this.showBigWin();
            } else {
                this.showRegularWin();
            }
        } else {
            this.time.delayedCall(1000, () => {
                this.ticketFinished();
            });
        }
    }

    ticketFinished()
    {
        this.fadeInMainFader();

        this.tweens.add({
            targets: [this.mainSound, this.mainAmbSound],
            volume: 1,
            duration: 500,
        });

        store.commit('hideCustomPlayButton');
        store.commit('showPlayButton');
        this.request.ticketFinished();
    }

    createFader()
    {
        this.fullFaderMain = this.add.graphics().fillStyle(0x000000, 1).fillRect(0, 0, 1920, 1920);
        this.fullFaderMain.setAlpha(0.4);
    }

    fadeInMainFader(alpha)
    {
        this.children.bringToTop(this.fullFaderMain);
        this.tweens.add({
            targets: this.fullFaderMain,
            alpha: alpha ? alpha : 0.4,
            ease: 'Power0',
            duration: 500
        });
    }

    createBg()
    {
        this.bg = this.add.sprite(0, 0, 'bg').setOrigin(0.5, 0);
        this.positionerContainer.add(this.bg);

        this.snowParticlesBack = this.add.particles('snow_particle');

        let width = 1920;

        this.snowParticlesBack.createEmitter({
            x: 0,
            y: -100,
            // emitZone
            emitZone: {
                source: new Phaser.Geom.Rectangle(-width * 3, 0, width * 7, 100),
                type: 'random',
                quantity: 70
            },
            speedY: { min: 50, max: 70 },
            speedX: { min: -20, max: 20 },
            accelerationY: { random: [10, 15] },
            // lifespan
            lifespan: { min: 8000, max: 15000 },
            scale: { random: [0.25, 0.75] },
            alpha: { random: [0.1, 0.8] },
            gravityY: 10,
            frequency: 20,
            blendMode: 'ADD',
        })
    }

    createBonus()
    {
        this.bonusContainer = this.add.container().setAlpha(0);

        this.bonusSnow = this.add.sprite(0, 0, 'snow').setOrigin(0.5, 1).setAlpha(0);
        this.bonusSnowFront = this.add.sprite(0, 0, 'snow_front').setOrigin(0.5, 1).setAlpha(0);
        this.bonusContainer.add(this.bonusSnow);
        this.gifts = {};

        for (let i = 1; i <= 3; i++) {
            this.gifts[i] = this.add.sprite(0, 0, `gift_${i}_open`).setFrame(`Gift_0${i}_Open_0000.png`);
            this.gifts[i].mouseOverSprite = this.add.sprite(0, 0, `gift_${i}_mouseover`).setAlpha(0);
            this.gifts[i].loose = this.add.sprite(0, 0, `gift_${i}_loose`).setAlpha(0);

            const amount = General.format_currency(0).replace(Config.currency.symbol, '');
            this.gifts[i].giftPrizeGlow = this.add.sprite(0, 0, 'win_glow').setAlpha(0);
            this.gifts[i].amount = this.customHelper.createWinningFromSprites(amount, 1, '_bonus_win', -10).setAlpha(0);
            this.gifts[i].amountLost = this.customHelper.createWinningFromSprites(amount, 1, '_bonus_loose', -10).setAlpha(0);
            this.bonusContainer.add(this.gifts[i]);
            this.bonusContainer.add(this.gifts[i].mouseOverSprite);
            this.bonusContainer.add(this.gifts[i].loose);
            this.bonusContainer.add(this.gifts[i].giftPrizeGlow);
            this.bonusContainer.add(this.gifts[i].amount);
            this.bonusContainer.add(this.gifts[i].amountLost);

            let animationConfig = {
                key: `gift_${i}_open`,
                skipMissedFrames: true,
                frames: this.anims.generateFrameNames(`gift_${i}_open`, {
                    prefix: `Gift_0${i}_Open_`,
                    start: 0,
                    end: 45,
                    suffix: '.png',
                    zeroPad: 4
                }),
                frameRate: 25
            };

            this.anims.create(animationConfig);
        }

        this.gifts[1].giftPrizeGlow.setAngle(-15);
        this.gifts[3].giftPrizeGlow.setAngle(15);

        this.bonusContainer.add(this.bonusSnowFront);
    }

    createWheel()
    {
        ['Long', 'Short'].forEach((size) => {
            ['Up', 'Down'].forEach((direction) => {
                for (let i = 1; i < 4; i++) {
                    let frameName = `Wheel_${size}_Board_0${i}_Flip_${direction}_`;
                    let keyName = `${size}_${i}_flip_${direction}`;

                    let animationConfig = {
                        key: keyName.toLowerCase(),
                        skipMissedFrames: true,
                        frames: this.anims.generateFrameNames(keyName.toLowerCase(), {
                            prefix: frameName,
                            start: 0,
                            end: 5,
                            suffix: '.png',
                            zeroPad: 4
                        }),
                        frameRate: 25
                    };

                    this.anims.create(animationConfig);
                }
            });
        });

        this.starParticles = this.createDustEmitter(0, 0, 70, 70, 'yellow', 0.2, false, 1);
        this.unluckyStarsParticles = [];

        for (let i = 0; i < this.unluckyStarsCount; i++) {
            let particle = this.createDustEmitter(0, 0, 70, 70, 'yellow', 0.2, false, 1);
            this.unluckyStarsParticles.push(particle);
        }

        this.wheelContainer = this.add.container();
        this.spinContainer = this.add.container();

        this.wheelLeg = this.add.sprite(0, 0, 'wheel_leg');
        this.wheelContainer.add(this.wheelLeg);

        this.wheelContainer.add(this.spinContainer);

        this.wheelBase = this.add.sprite(0, 0, 'wheel_lights');
        this.spinContainer.add(this.wheelBase);

        this.wheelStar = this.add.sprite(0, 0, 'gift_loop').setAlpha(0);
        this.wheelStar.starParticles = this.starParticles;
        this.spinContainer.add(this.wheelStar);

        this.unluckyStars = [];

        for (let i = 0; i < this.unluckyStarsCount; i++) {
            let star = this.add.sprite(0, 0, 'gift_loop').setAlpha(0);
            star.starParticles = this.unluckyStarsParticles[i];

            this.unluckyStars.push(star);
            this.spinContainer.add(star);
        }

        let wheelStep = 360 / 20;
        this.wheelAngles = {};
        this.wheelAmounts = {};

        this.wheelBoards = {};
        let boardRadius = 218;

        let prizesRadius = 280;
        let color = '_light';

        for (let i = 0; i < 20; i++) {
            this.wheelAngles[i] = i * wheelStep;

            const amount = General.format_currency(0).replace(Config.currency.symbol, '');
            let theta = (i - 2.53) * (Math.PI * 2) / 20;

            let x = boardRadius * Math.cos(theta);
            let y = boardRadius * Math.sin(theta);
            let angle = (360 / 20) * (i) + 315;

            this.wheelBoards[i] = this.add.sprite(0, 0, this.wheelBoardSettings[i]['spriteName']).setX(x).setY(y).setAngle(angle).setFrame(this.wheelBoardSettings[i]['frame']);
            this.spinContainer.add(this.wheelBoards[i]);

            let prizeX = prizesRadius * Math.cos(theta);
            let prizeY = prizesRadius * Math.sin(theta);
            this.wheelAmounts[i] = {};

            this.wheelAmounts[i].amount = this.customHelper.createWinningFromSprites(amount, 0.6, color).setX(prizeX).setY(prizeY).setAngle(angle).setAlpha(0);
            this.spinContainer.add(this.wheelAmounts[i].amount);

            let distance = 490;

            let starTheta = (i - 2.5) * (Math.PI * 2) / 20;
            let starX = distance * Math.cos(starTheta);
            let starY = distance * Math.sin(starTheta);

            this.wheelAmounts[i].starPosition = {x:starX, y:starY, angle: angle + 90};

            color = color === '_dark' ? '_light' : '_dark';
        }

        let animationConfig = {
            key: 'bonus_gift_activate',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('bonus_gift_activate', {
                prefix: 'Gift_Activate_',
                start: 0,
                end: 63,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'gift_loop',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('gift_loop', {
                prefix: 'Gift_Idle_Loop_',
                start: 0,
                end: 29,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
            repeat: -1
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'win_fx',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('win_fx', {
                prefix: 'Win_FX_',
                start: 0,
                end: 43,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
            showOnStart: true,
            hideOnComplete: true
        };

        this.anims.create(animationConfig);

        animationConfig = {
            key: 'win_glow',
            skipMissedFrames: true,
            frames: this.anims.generateFrameNames('win_glow', {
                prefix: 'Win_GLOW_',
                start: 0,
                end: 27,
                suffix: '.png',
                zeroPad: 4
            }),
            frameRate: 25,
            repeat: -1
        };

        this.anims.create(animationConfig);

        this.tempMatrix = new Phaser.GameObjects.Components.TransformMatrix();
        this.tempParentMatrix = new Phaser.GameObjects.Components.TransformMatrix();

        this.setStarPosition(this.wheelStar, 0);

        // drag rotate plugin instance
        this.wheelDragRotate = this.plugins.get("rexDragRotate").add(this, {
            // horizontal coordinate of origin point
            x: this.wheelBase.x + this.wheelContainer.x,

            // vertical coordinate of origin point
            y: this.wheelBase.y + this.wheelContainer.y,

            // dragging is valid when distance between touch pointer and
            // origin position is larger then minRadius and less then maxRadius.
            minRadius: 0,
            maxRadius: 440
        });

        this.dragged = false;

        // the core of the script, "drag" listener
        this.wheelDragRotate.on("drag", (wheelDragRotate) => {
            this.dragged = true;
            this.spinContainer.angle += wheelDragRotate.deltaAngle;

            if (wheelDragRotate.cw) {
                this.spin('normal');
                this.wheelDragRotate.setEnable(false);
            }
            if (wheelDragRotate.ccw) {
                this.spin('counter');
                this.wheelDragRotate.setEnable(false);
            }

        })
            .on('dragend', (wheelDragRotate) => {
                if (!this.dragged) {
                    this.spin('normal');
                    this.wheelDragRotate.setEnable(false);
                }
            });

        this.wheelDragRotate.setEnable(false);
    }

    setStarPosition(star, i)
    {
        star
            .setX(this.wheelAmounts[i].starPosition.x)
            .setY(this.wheelAmounts[i].starPosition.y)
            .setAngle(this.wheelAmounts[i].starPosition.angle)
            .setFrame('Gift_Idle_Loop_0000.png');

        this.particleFollowStars();
    }

    particleFollowStars()
    {
        this.particleFollowStar(this.wheelStar);

        for (let i = 0; i < this.unluckyStarsCount; i++) {
            this.particleFollowStar(this.unluckyStars[i]);
        }
    }

    particleFollowStar(star)
    {
        this.tempMatrix = new Phaser.GameObjects.Components.TransformMatrix();
        this.tempParentMatrix = new Phaser.GameObjects.Components.TransformMatrix();

        star.getWorldTransformMatrix(this.tempMatrix, this.tempParentMatrix);
        let decompressed = this.tempMatrix.decomposeMatrix();

        star.starParticles.emitter.setPosition(decompressed.translateX, decompressed.translateY)
    }

    createMultiplier()
    {
        this.multiplierContainer = this.add.container();
        this.multiplierSpinContainer = this.add.container();

        this.multiplierWheelBase = this.add.sprite(0, 0, 'multiplier_wheel_shadow');
        this.multiplierContainer.add(this.multiplierWheelBase);

        this.multiplierContainer.add(this.multiplierSpinContainer);

        this.multiplierWheel = this.add.sprite(0, 0, 'multiplier_wheel');
        this.multiplierSpinContainer.add(this.multiplierWheel);

        this.amountsCoors = {
            1: {x:65, y: -65, angle: 45},
            2: {x: 65, y: 65, angle: 135},
            3: {x:-65, y: 65, angle: -135},
            4: {x:-65, y: -65, angle: -45},
        };

        this.multiplierWheelAnglesCounter = { 0: 0, 1: 90, 2: 180, 3:270};

        this.multiplierWheelAngles = { 0: 0, 1: 270, 2: 180, 3:90};

        this.multiplierWheelAmounts = {};

        this.multiplierWheelStep = 360 / 4;
        Config.odds.multipliers.forEach((item, index) => {
            this.multiplierWheelAmounts[index] = this.add.sprite(this.amountsCoors[index+1].x, this.amountsCoors[index+1].y, `x${item}`).setAngle(this.amountsCoors[index+1].angle);
            this.multiplierSpinContainer.add(this.multiplierWheelAmounts[index]);

            this.multiplierWheelAmounts[index].lucky = this.add.sprite(this.amountsCoors[index+1].x, this.amountsCoors[index+1].y, `x${item}_win`).setAngle(this.amountsCoors[index+1].angle).setAlpha(0);
            this.multiplierSpinContainer.add(this.multiplierWheelAmounts[index].lucky);

            this.multiplierWheelAmounts[index].angleStart = index === 1 ? 0 : this.multiplierWheelAngles[index] - (this.multiplierWheelStep / 2);
            this.multiplierWheelAmounts[index].angleEnd = this.multiplierWheelAngles[index] + (this.multiplierWheelStep / 2);
        });

        this.winFrame = this.add.sprite(175, -155, 'win_frame');
        this.multiplierContainer.add(this.winFrame);

        this.wheelWinFx = this.add.sprite(205, -205, 'win_fx').setVisible(false);
        this.multiplierContainer.add(this.wheelWinFx);
    }

    createDustEmitter(x, y, width, height, particleColor, maxParticleSize, type, quantity, toAlphaZero)
    {
        let circle;

        if (type === 'curve') {
            circle = new Phaser.Curves.Ellipse(x, y, width, height);
        } else {
            circle = new Phaser.Geom.Ellipse(x, y, width, height);
        }

        let particles = this.add.particles('flares');

        particleColor = particleColor ? particleColor : 'yellow';
        maxParticleSize = maxParticleSize ? maxParticleSize : 0.1;
        quantity = quantity ? quantity : 1;

        let config = {
            frame: [particleColor],
            lifespan: {
                'min': 100,
                'max': 1000
            },
            speedX: {
                min: -30,
                max: 30
            },
            speedY: {
                min: -30,
                max: 30
            },
            quantity: quantity,
            scale: {
                min: 0.01,
                max: maxParticleSize,
                end: 0
            },
            blendMode: 'ADD',
            frequency: 5,
            emitZone: {
                type: 'random',
                source: circle,
                quantity: 10,
                stepRate: 1,
                yoyo: false,
                seamless: true
            },
            on: false
        };

        if (toAlphaZero) {
            config['alpha'] =  { start: 1, end: 0, ease: 'Expo.easeIn'};
        }

        particles.emitter = particles.createEmitter(config);

        let currentGravityX = 50;

        particles.triggerTimer = this.time.addEvent({
            callback: () => {
                currentGravityX = currentGravityX * -1
                particles.emitter.setGravity(currentGravityX, 0);
            },
            callbackScope: this,
            delay: 1000,
            loop: true,
            paused: true
        });

        return particles;
    }

    stopTweens()
    {
        if (this.bonusContainer.tween && this.bonusContainer.tween.isPlaying()) {
            this.bonusContainer.tween.complete();
        }

        for (let i = 1; i <= 3; i++) {
            if (this.gifts[i].tween && this.gifts[i].tween.isPlaying()) {
                this.gifts[i].tween.complete();
            }

            if (this.gifts[i].amountLost && this.gifts[i].amountLost.tween && this.gifts[i].amountLost.tween.isPlaying()) {
                this.gifts[i].amountLost.tween.complete();
            }
        }
    }

    gamePositioner()
    {
        if (!this.spritesReady) {
            return;
        }

        this.stopTweens();

        this.regularWinPositioner();
        this.bigWinPositioner();

        if (this.orientationIsSetToPortrait()) {
            this.bg.setTexture('bg_portrait');
            this.wheelContainer.setX(this.cameras.main.centerX).setY(this.wheelBase.height / 2 + 10 + 250);

            this.glow_for_logo.setX(this.glow_for_logo.width / 2 - 60).setY(this.glow_for_logo.height / 2 - 60)
            this.santa.setX(350).setY(this.cameras.main.height - 85);
            this.bonusContainer.setY(100).setX(this.cameras.main.centerX - 90).setScale(0.90);
        } else {
            this.bg.setTexture('bg');
            this.glow_for_logo.setX(this.glow_for_logo.width / 2 - 40).setY(this.glow_for_logo.height / 2 - 40)
            this.santa.setX(195).setY(this.cameras.main.height - 85);
            this.wheelContainer.setX(1200).setY(this.wheelBase.height / 2 + 10);
            this.bonusContainer.setY(0).setX(this.cameras.main.centerX).setScale(1);
        }

        this.wheelDragRotate.setOrigin(this.wheelBase.x + this.wheelContainer.x, this.wheelBase.y + this.wheelContainer.y);

        this.logo.setX(this.glow_for_logo.x).setY(this.glow_for_logo.y);
        this.wizardSmoke.setX(this.santa.x + 90).setY(this.santa.y - 530);

        this.wheelLeg.setX(50).setY(this.wheelBase.height / 2 - 100);

        this.multiplierContainer
            .setX(this.wheelContainer.x)
            .setY(this.wheelContainer.y);

        this.bonusContainer.initialY = this.bonusContainer.y;

        this.bonusSnow.setY(this.cameras.main.height);
        this.bonusSnowFront.setX(110).setY(this.bonusSnow.y - 140);

        this.gifts[1].setX(-265).setY(this.bonusSnow.y - this.bonusSnow.height + 90);
        this.gifts[2].setX(145).setY(this.bonusSnow.y - this.bonusSnow.height + 260);
        this.gifts[3].setX(500).setY(this.bonusSnow.y - this.bonusSnow.height + 160);

        let prizeGlowOffsets = {
            1: {x: -35, y: -110},
            2: {x: 0, y: -110},
            3: {x: 35, y: -110}
        };

        for (let i = 1; i <= 3; i++) {
            this.gifts[i].mouseOverSprite.setX(this.gifts[i].x).setY(this.gifts[i].y);
            this.gifts[i].loose.setX(this.gifts[i].x).setY(this.gifts[i].y);

            this.gifts[i].initialX = this.gifts[i].x;
            this.gifts[i].initialY = this.gifts[i].y;

            this.gifts[i].giftPrizeGlow.setX(this.gifts[i].x + prizeGlowOffsets[i].x).setY(this.gifts[i].y + prizeGlowOffsets[i].y);

            if (this.gifts[i].amount) {
                this.gifts[i].amount.setX(this.gifts[i].giftPrizeGlow.x).setY(this.gifts[i].giftPrizeGlow.y).setAngle(this.gifts[i].giftPrizeGlow.angle);
            }

            if (this.gifts[i].amountLost) {
                if (this.gifts[i].amountLost.tween && this.gifts[i].amountLost.tween.isPlaying()) {
                    this.gifts[i].amountLost.stop();
                }

                this.gifts[i].amountLost.setX(this.gifts[i].x).setY(this.gifts[i].y + 40).setAngle(this.gifts[i].giftPrizeGlow.angle);
            }
        }

        this.gifts[3].mouseOverSprite.setX(this.gifts[3].x).setY(this.gifts[3].y + 11);
        this.gifts[2].mouseOverSprite.setX(this.gifts[2].x).setY(this.gifts[2].y + 3);

        this.gifts[3].loose.setX(this.gifts[3].mouseOverSprite.x).setY(this.gifts[3].mouseOverSprite.y);
        this.gifts[2].loose.setX(this.gifts[2].mouseOverSprite.x).setY(this.gifts[2].mouseOverSprite.y);

        this.gifts[1].amountLost.setX(this.gifts[1].x + 35);
        this.gifts[3].amountLost.setX(this.gifts[3].x - 15);

        let shape = new Phaser.Geom.Rectangle(-(this.cameras.main.width/2), -(this.cameras.main.height/2), this.cameras.main.width, this.cameras.main.height);

        this.bigWinShineEmitter.setEmitZone({
            type: 'random',
            source: shape,
            seamless: true
        });

        this.bigWinShineEmitter2.setEmitZone({
            type: 'random',
            source: shape,
            seamless: true
        });

        this.bigWinShineEmitter.setPosition(this.cameras.main.centerX, this.cameras.main.centerY);
        this.bigWinShineEmitter2.setPosition(this.cameras.main.centerX, this.cameras.main.centerY);

        if (this.request.scenario && this.request.scenario.star_position) {
            this.setStarPosition(this.wheelStar, this.request.scenario.star_position);

            for (let i = 0; i < this.unluckyStarsCount; i++) {
                this.setStarPosition(this.unluckyStars[i], this.request.scenario.unlucky_stars[i]);
            }
        }
    }

    properties()
    {
        this.wheelBoardSettings = {
            0: {
                spriteName: 'long_3_flip_up',
                frame: 'Wheel_Long_Board_03_Flip_Up_0000.png'
            },
            1: {
                spriteName: 'short_2_flip_up',
                frame: 'Wheel_Short_Board_02_Flip_Up_0000.png'
            },
            2: {
                spriteName: 'long_1_flip_up',
                frame: 'Wheel_Long_Board_01_Flip_Up_0000.png'
            },
            3: {
                spriteName: 'short_1_flip_up',
                frame: 'Wheel_Short_Board_01_Flip_Up_0000.png'
            },
            4: {
                spriteName: 'long_3_flip_up',
                frame: 'Wheel_Long_Board_03_Flip_Up_0000.png'
            },
            5: {
                spriteName: 'short_2_flip_up',
                frame: 'Wheel_Short_Board_02_Flip_Up_0000.png'
            },
            6: {
                spriteName: 'long_1_flip_up',
                frame: 'Wheel_Long_Board_01_Flip_Up_0000.png'
            },
            7: {
                spriteName: 'short_1_flip_up',
                frame: 'Wheel_Short_Board_01_Flip_Up_0000.png'
            },
            8: {
                spriteName: 'long_2_flip_up',
                frame: 'Wheel_Long_Board_02_Flip_Up_0000.png'
            },
            9: {
                spriteName: 'short_3_flip_up',
                frame: 'Wheel_Short_Board_03_Flip_Up_0000.png'
            },
            10: {
                spriteName: 'long_3_flip_up',
                frame: 'Wheel_Long_Board_03_Flip_Up_0000.png'
            },
            11: {
                spriteName: 'short_2_flip_up',
                frame: 'Wheel_Short_Board_02_Flip_Up_0000.png'
            },
            12: {
                spriteName: 'long_1_flip_up',
                frame: 'Wheel_Long_Board_01_Flip_Up_0000.png'
            },
            13: {
                spriteName: 'short_1_flip_up',
                frame: 'Wheel_Short_Board_01_Flip_Up_0000.png'
            },
            14: {
                spriteName: 'long_2_flip_up',
                frame: 'Wheel_Long_Board_02_Flip_Up_0000.png'
            },
            15: {
                spriteName: 'short_2_flip_up',
                frame: 'Wheel_Short_Board_02_Flip_Up_0000.png'
            },
            16: {
                spriteName: 'long_1_flip_up',
                frame: 'Wheel_Long_Board_01_Flip_Up_0000.png'
            },
            17: {
                spriteName: 'short_1_flip_up',
                frame: 'Wheel_Short_Board_01_Flip_Up_0000.png'
            },
            18: {
                spriteName: 'long_2_flip_up',
                frame: 'Wheel_Long_Board_02_Flip_Up_0000.png'
            },
            19: {
                spriteName: 'short_3_flip_up',
                frame: 'Wheel_Short_Board_03_Flip_Up_0000.png'
            }
        }
    }
}


class AnimatedParticle extends Phaser.GameObjects.Particles.Particle
{
    constructor (emitter)
    {
        super(emitter);

        this.t = 0;
        this.i = Math.floor(Math.random() * 21);
    }

    update (delta, step, processors)
    {
        var result = super.update(delta, step, processors);

        this.t += delta;

        if (this.t >= bigWinShineAnim.msPerFrame)
        {
            this.i++;

            if (this.i > 21)
            {
                this.i = 0;
            }

            this.frame = bigWinShineAnim.frames[this.i].frame;

            this.t -= bigWinShineAnim.msPerFrame;
        }

        return result;
    }
}

startGame(GameScene);